import { createAction } from '@reduxjs/toolkit'
import { Company } from '@leadgen/models/client'

class CompanyActions {
  companyLoaded = createAction('company/companyLoaded', (company: Company) => ({
    payload: company,
  }))
  updateCompany = createAction('company/updateCompany', (company: Company) => ({
    payload: company,
  }))
  updateCompanyMonthlyCreditLimit = createAction(
    'company/updateCompanyMonthlyCreditLimit',
    (monthlyCreditLimit: number) => ({
      payload: monthlyCreditLimit,
    }),
  )
  updateLastChangedTemplate = createAction(
    'company/updateLastChangedTemplate',
    ({ lastChangedTemplateVersion }: { lastChangedTemplateVersion: number }) => ({
      payload: {
        lastChangedTemplateVersion,
      },
    }),
  )
  cancelSubscription = createAction('company/cancelSubscription', () => ({
    payload: null,
  }))
  switchCard = createAction(
    'company/switchCard',
    ({ companyCardId }: { companyCardId: string }) => ({
      payload: { companyCardId },
    }),
  )
  topup = createAction('company/topup', ({ clientSecret }: { clientSecret: string | null }) => ({
    payload: { clientSecret },
  }))
  purchaseSubscription = createAction(
    'company/purchaseSubscription',
    ({
      paymentMethodId,
      intentType,
      clientSecret,
    }: {
      paymentMethodId?: string
      intentType: 'payment' | 'setup'
      clientSecret: string | null
    }) => ({
      payload: { paymentMethodId, intentType, clientSecret },
    }),
  )
  paymentSyncFailed = createAction('company/paymentSyncFailed')
}

export default new CompanyActions()
